export default {
  formFields: {
    'fieldHelp': 'Haga clic para abrir la descripción del campo',
    'defaultAbbreviation': 'Est.: ',
    'paramJSONContent': 'contenido JSON',
    'wrongInputValue': 'Valor de entrada incorrecto para este parámetro.',
    'notValidJsonString': 'JSON no es válido para :fieldName'
  }
}
